import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<{ showValidationErrors: boolean }>;

export const DispatchSetShowValidationErrors: HandlerType = props => {
    props.dispatch({
        type: "Shipping/SetShowValidationErrors",
        showValidationErrors: props.parameter.showValidationErrors,
    });
};

export const chain = [DispatchSetShowValidationErrors];

const setShowValidationErrors = createHandlerChainRunner(chain, "SetShowValidationErrors");
export default setShowValidationErrors;
